import { TagStatus as TagStatusSeiue } from '@seiue/ui'
import { FC } from 'react'
import styled from 'styled-components'

export const TagStatus = styled(TagStatusSeiue)<{ $isLight?: boolean }>`
  // 获取 第一个子 span 元素
  &&& {
    font-weight: normal;
    & > span:first-child {
      width: 6px;
      height: 6px;
    }
    color: ${(props) =>
      props.$isLight ? props.theme.text._2 : props.theme.text._1};
  }
`
